const favoriteSubtle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path stroke-width="1.5" d="m13.827 6.748-3.592 2.814 1.37 4.224L8 11.164l-3.606 2.622 1.371-4.224-3.592-2.814h4.36L8 2.532l1.467 4.216z"/></svg>',
};

export { favoriteSubtle as default };
